module.exports = __webpack_public_path__ + "static/media/circle-alert-v2.4e434670.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/circle-alert-v2.svg
// module id = 735
// module chunks = 0